import { getLoggedOrPlannedAtWorkoutUtil } from '../../../../../modules/workout/model/utils/get-logged-or-planned-at'
import { getWeekStrDateUtil } from 'packages/src'

export default function getWeekStrWorkoutUtil (workout) {
  const loggedAtOrPlannedAt = getLoggedOrPlannedAtWorkoutUtil(workout)
  return getWeekStrDateUtil(new Date(loggedAtOrPlannedAt))
}
